import React, {useState} from 'react';
import {createRoot} from 'react-dom/client';
import AppCartMain from "./app.cart.main";
import '../styles/app.cart.theme.css'
import {BrowserRouter, Route} from "react-router-dom";
import {ApolloClient, ApolloProvider, HttpLink, InMemoryCache, from, ApolloLink} from "@apollo/client";
import {onError} from "@apollo/client/link/error";
import { RetryLink } from "@apollo/client/link/retry";
import AppAuthLoginFormModal from "./auth/app.auth.loginform.modal";
import {cancelLastRequest} from "./auth/app.auth.actions";
import {AuthProvider} from "./auth/app.auth.context";
import Cookies from "js-cookie";
import {clientPrivate} from "../config/apollo_client";
import AppAuthModalPopup from "./auth/app.auth.modalpopup"
//let hdr = {};
//let showAuth = null;



/*
const addError = (errors, errorItem) => {

    if(!errors){
        errors = [];
    }

    errors.push(errorItem);

    return errors;

};



let csrf = Cookies.get('csrftoken');

const httpLink = new HttpLink({uri:'/front2api/'});

// middleWare creation
const securityMiddleware = new ApolloLink((operation,forward) => {
    operation.setContext(({headers = {}}) => ({
        headers: {
            ... headers,
            csrf: Cookies.get('csrftoken') || null
        }
    }));

    return forward(operation);
})


const errorLink = onError(({ graphQLErrors,networkError,response }) => {

    // перебрать массив ошибок, исключив глобальные ошибки
    let filtered_errors = null;
    if(graphQLErrors){
        console.log('graphQLErrors', graphQLErrors);

        for (let err of graphQLErrors){

            switch (err.extensions.code){
                case '401':{
                    // авторизация с последующим редиректом на необходимую страницу
                    // показываем авторизацию

                    // if(showAuth) {
                    //     showAuth();
                    // }else{
                    // если не показываем авторизацию, то отправить эту ошибку дальше
                    err.isAborted = true;
                    filtered_errors = addError(filtered_errors, err);
                    // }

                    // console.log("erro is aborted");
                    // console.log(err);
                }
                    break;
                // все не обработанные ошибки передать дальше по цепочке
                default:{
                    err.isAborted = false;
                    filtered_errors = addError(filtered_errors, err);

                }
            }
        }

    }
    if(networkError){
        console.log(`Network error:   ${networkError}`);
    }

    //если происходит ошибка networkError то response может быть nil
    if(response){
        response.errors = filtered_errors;
    }
});



const client = new ApolloClient({
    //uri: '/front2api/',
    link: from([RetryLink, errorLink, securityMiddleware,httpLink]),
    cache: new InMemoryCache(),
    credentials: 'same-origin',
    headers: hdr
});

*/


/*
const AppCartAuth = () => {

    const[showLogin,setShowLogin] = useState(false);
    const toggleLogin = () => {
        setShowLogin(!showLogin)
        cancelLastRequest().catch();
    };

    showAuth = () => {
        setShowLogin(true);
    }


    return(
            <AppAuthLoginFormModal show={showLogin} toggle={toggleLogin} className="loginform"/>
    )
}
*/


const AppCart = (
            <ApolloProvider client={clientPrivate}>
                <AuthProvider>
                    <BrowserRouter>
                        <AppCartMain/>
                        {/*<AppCartAuth/>*/}
                    </BrowserRouter>
                    <AppAuthModalPopup/>
                </AuthProvider>
            </ApolloProvider>)
;



const el = document.getElementById('app_cart');
if(el){
    const root = createRoot(el);
    root.render(AppCart);
}
